import React, { PropsWithChildren } from "react";
import { RolesGuardProps } from "../../../interfaces/props/RolesGuardProps";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_PROFILE_ROLE } from "../../../store/selectors/profileSelectors";

/** Guard по роли пользователя
 * @param roles - список разрешенных ролей пользователя
 */
export const RoleGuard = ({
  roles,
  children,
}: PropsWithChildren<RolesGuardProps>) => {
  const userRole = useAppSelector(SELECT_PROFILE_ROLE);
  if (!userRole) {
    return null;
  }

  if (roles?.includes(userRole)) {
    return <>{children}</>;
  }

  return null;
};
